'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CrmObjectWorkflowEmailSent = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CRM_OBJECT_WORKFLOW_EMAIL_SENT), _defineProperty(_Record, 'emailMessageId', null), _defineProperty(_Record, 'emailSubject', null), _defineProperty(_Record, 'id', null), _defineProperty(_Record, 'messageDeletedStatus', null), _defineProperty(_Record, 'objectId', null), _defineProperty(_Record, 'objectType', null), _defineProperty(_Record, 'timestamp', null), _defineProperty(_Record, 'workflowId', null), _Record), 'CrmObjectWorkflowEmailSent');

exports.default = CrmObjectWorkflowEmailSent;
module.exports = exports['default'];